<template>
  <Page>
    <SidePageColumn side="left">
      <v-list shaped dense max-width="98.5%" class="grey lighten-5">
        <v-subheader class="pl-5">Panel Managment Menu</v-subheader>
        <v-list-item-group color="primary" class="pl-3">
          <SideMenuItem
            v-for="(menu_item, index) in owner_menu_objects"
            :key="index"
            :to="menu_item.to"
            :icon="menu_item.icon"
            :label="menu_item.label"
          ></SideMenuItem>
        </v-list-item-group>
      </v-list>
    </SidePageColumn>
    <CenterPageColumn :has_nav_bar="true">
      <router-view
        :user="user"
        :is_loading="is_loading"
        @on-show-loader="$emit('on-hide-loader')"
        @on-hide-loader="$emit('on-show-loader')"
        @on-show-login-modal="on_show_login_modal"
      ></router-view>
      <Footer
        :is_loading="is_loading"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
      ></Footer>
    </CenterPageColumn>
  </Page>
</template>
<script>
import Page from "./../../components/Page";
import SidePageColumn from "./../../components/SidePageColumn";
import NavbarMenuItem from "../../components/NavbarMenuItem";
import SideMenuItem from "../../components/SideMenuItem";
import ServerClient from "../../lib/ServerClient";
import Utils from "../../lib/Utils";
import CenterPageColumn from "./../../components/CenterPageColumn";
import Footer from "./../../components/CenterFooter";
export default {
  name: "Owner",
  components: {
    Page,
    NavbarMenuItem,
    SideMenuItem,
    SidePageColumn,
    CenterPageColumn,
    Footer,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    }
  },
  data: () => {
    return {
      owner_menu_objects: [
        {
          label: "Dashboard",
          icon: "mdi-home-city-outline",
          to: "/owner/dashboard",
          roles: ["owner"],
        },
        {
          label: "Promotions",
          icon: "mdi-home-city-outline",
          to: "/owner/promotions",
          roles: ["owner"],
        },
        {
          label: "Businesses",
          icon: "mdi-home-city-outline",
          to: "/owner/businesses",
          roles: ["owner"],
        },
        {
          label: "Notifications",
          icon: "mdi-home-city-outline",
          to: "/owner/notifications",
          roles: ["owner"],
        },
        {
          label: "users",
          icon: "mdi-home-city-outline",
          to: "/owner/users",
          roles: ["owner"],
        }
      ],
      user: null, //digitalocean@2015
    };
  },
  methods: {
    can_access(menu_item) {
      var res = Utils.can_access(this.user, menu_item);
      return res;
    },
    on_show_login_modal(config){
      this.$emit("on-show-login-modal",config);
    }
  },
  mounted() {
    this.user = ServerClient.Login.get_logged_in_user();
   // console.log("the user", this.user);
  },
};
</script>